import type { ProductCode } from "./products.ts";
import type { Session } from "./session.ts";

const ALL_PRODUCTS = "all";

function hasAssignation(assignations: string[] | undefined, product: ProductCode) {
    return !!assignations?.some(assignation => {
        const id = assignation.toLowerCase();

        return id === product || id === ALL_PRODUCTS;
    });
}

export type Role = (session: Session | null | undefined) => boolean;

export function isReportingManager(session: Session | null | undefined) {
    return !!session?.isReportingManager;
}

export function isExecutive(session: Session | null | undefined) {
    return !!session?.isExecutive;
}

export function isTeamManager(session: Session | null | undefined) {
    return !!session?.isTeamManager;
}

export function isCollaborator(session: Session | null | undefined) {
    return !!session?.isCollaborator;
}

export function isOrganizationAdmin(session: Session | null | undefined) {
    return !!session?.isOrganizationAdmin;
}

export function isPlatformExecutive(session: Session | null | undefined) {
    return isExecutive(session) && !!session?.executiveAssignations?.some(assignation => assignation.toLowerCase() === ALL_PRODUCTS);
}

export function isProductExecutive(product: ProductCode): Role {
    return session => hasAssignation(session?.executiveAssignations, product);
}

export function isProductCollaborator(product: ProductCode): Role {
    return session => hasAssignation(session?.collaboratorAssignations, product);
}

export function isIndividualContributor(session: Session | null | undefined) {
    return !!session && !isReportingManager(session) && !isExecutive(session);
}

export function isPureReportingManager(session: Session | null | undefined) {
    return isReportingManager(session) && !isOrganizationAdmin(session) && !isPlatformExecutive(session);
}

export function hasAnyRole(session: Session | null | undefined, roles: readonly Role[]) {
    return roles.some(role => role(session));
}
